import { action } from 'satcheljs';
import { INotificationBarItem } from '../../components/NotificationBar';

export const onNotificationChanged = action('onNotificationChanged', (notification: INotificationBarItem) => ({
  notification,
}));

export const onNotificationRemoved = action('onNotificationRemoved', (notification: INotificationBarItem) => ({ notification }));
